import { useEffect } from "react";

const COOKIES_TO_REMOVE = ["_ga", "_gid", "AMD_", "XSRF-TOKEN"];

export function useClearAnalyticsCookies() {
  useEffect(() => {
    const clearCookies = () => {
      const cookies = document.cookie.split(";");

      cookies.forEach((cookie) => {
        const cookieName = cookie.split("=")[0].trim();

        if (COOKIES_TO_REMOVE.some((name) => cookieName.startsWith(name))) {
          // Remove cookie for all possible domains and paths
          const domains = [
            window.location.hostname,
            `.${window.location.hostname}`,
            window.location.hostname.split(".").slice(1).join("."),
            `.${window.location.hostname.split(".").slice(1).join(".")}`,
          ];

          domains.forEach((domain) => {
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain}`;
          });
        }
      });
    };

    clearCookies();
  }, []);
}
